export const EVENTS = {
  PROFILE: {
    OPEN: 'profile.open'
  }
};
